import React, { useState, useEffect } from "react";
import { data, useOutletContext, useParams, useNavigate } from "react-router-dom";
import { getSahamId, postTransaksiSaham } from "../api/services/sahamApi";
import { currencyFormat } from "../components/utils/currencyFormat";
import SubmitButton from "../components/buttons/SubmitButton";
import InputText from "../components/forms/InputText";
import InputNumber from "../components/forms/InputNumber";
import Card from "../components/cards/Card";


function TambahTransaksiSaham() {
    
    /** Title Header Page */
    const {title, setTitle} = useOutletContext();
    setTitle('Tambah Transaksi');
    
    /** useState */
    const { sahamId } = useParams();
    const navigate = useNavigate();
    const [typeTransaksi, setTypeTransaksi] = useState('');
    const [dataSaham, setDataSaham] = useState([]);
    const [bayarSaham, setBayarSaham] = useState(0);
    const [bayarTabungan, setBayarTabungan] = useState(0);
    const [kurangiSaham, setKurangiSaham] = useState(0);
    const [kurangiTabungan, setKurangiTabungan] = useState(0);
    const [isSubmiting, setIsSubmiting] = useState(false);

    useEffect(() => {
        /** Title Tab Browser */
        document.title = 'Tambah Transaksi | Sembako';
        
        /** Get Data Detail Saham */
        getSahamId(sahamId).then(res => setDataSaham(res.data.data));

    },[])

    const totalNomerSahamBayar = parseInt(dataSaham.no_saham ?? '0') + parseInt(bayarSaham ?? 0);
    const totalUangSahamBayar = currencyFormat(15000 * (dataSaham.jml_saham ?? 0) * ((dataSaham.no_saham ?? 0) + parseInt(bayarSaham)));
    const totalTabunganBayar = currencyFormat(parseInt(dataSaham.tabungan ?? '0') + parseInt(bayarTabungan));
    const totalNomerSahamKurangi = parseInt(dataSaham.no_saham ?? '0') - parseInt(kurangiSaham ?? 0);
    const totalUangSahamKurangi = currencyFormat(15000 * (dataSaham.jml_saham ?? 0) * ((dataSaham.no_saham ?? 0) - parseInt(kurangiSaham)));
    const totalTabunganKurangi = currencyFormat(parseInt(dataSaham.tabungan ?? '0') - parseInt(kurangiTabungan));

    console.log((dataSaham.no_saham ?? 0) + bayarSaham);
    
    const handleSubmit = async(event) => {
        setIsSubmiting(true);
        event.preventDefault();
        try {
            const newPost = await postTransaksiSaham({
                id: dataSaham.id,
                typeTransaksi,
                jmlSaham : dataSaham.jml_saham,
                bayarSaham,
                bayarTabungan,
                kurangiSaham,
                kurangiTabungan
            });
            alert('Transaksi berhasil dibuat');
            navigate('/cari-saham/' + dataSaham.id);
        } catch (error) {
            alert('Gagal menambahkan saham')
            setIsSubmiting(false);
            console.log(error);
        }
    }





    return(
        <>
            <Card header={`No. ${dataSaham.nomer} - ${dataSaham.nama}`} />
            <h4 className="text-xl font-semibold mb-2 mt-3"></h4>
            <form onSubmit={handleSubmit}>
                <div className="mt-10">
                    <label>Jenis transaksi</label>
                    <select type="text" className="block w-full mt-3 mb-3 p-3 border-solid border-gray-200 border-3 rounded-2xl" value={typeTransaksi} onChange={(e) => setTypeTransaksi(e.target.value)}>
                        <option value="" selected>Pilih nomer saham</option>
                        <option value="bayar">Bayar</option>
                        <option value="ambil">Ambil / Kurangi</option>
                    </select>
                </div>
                {typeTransaksi == 'bayar' &&(
                    <>
                        <InputNumber
                            min={0}
                            label="Bayar Saham(jumlah nomer)" 
                            value={bayarSaham == 0 ? '' : bayarSaham}
                            onChange={(e) => setBayarSaham(e.target.value == '' ? 0 : e.target.value)}/>
                        <InputNumber 
                            min={0}
                            label="Bayar Tabungan(jumlah uang)" 
                            value={bayarTabungan == 0 ? '' : bayarTabungan}
                            onChange={(e) => setBayarTabungan(e.target.value == '' ? 0 : e.target.value)}/>
                        <Card
                            header="Sebelum :"
                            desc1={`Nomer Saham ${parseInt(dataSaham.no_saham ?? '0')} - ${currencyFormat(15000 * (dataSaham.jml_saham ?? 0) * (dataSaham.no_saham ?? 0))}`}
                            desc2={`Tabungan Rp. ${dataSaham.tabungan ?? '0'}`} />
                        <Card
                            header="Dibayar :"
                            desc1={`Nomer Saham ${parseInt(bayarSaham)} - ${currencyFormat(15000 * (dataSaham.jml_saham ?? 0) * (bayarSaham))}`}
                            desc2={`Tabungan ${currencyFormat(bayarTabungan ?? '0')}`} />
                        <Card
                            header="Sesudah :"
                            desc1={`Nomer Saham ${totalNomerSahamBayar} - ${totalUangSahamBayar}`}
                            desc2={`Tabungan ${totalTabunganBayar}`} />
                    </>
                )}
                {typeTransaksi == 'ambil' &&(
                    
                    <>
                        <InputNumber 
                            min={0}
                            label="Kurangi Saham(jumlah nomer)" 
                            value={kurangiSaham == 0 ? '' : kurangiSaham}
                            onChange={(e) => setKurangiSaham(e.target.value == '' ? 0 : e.target.value)}/>
                        <InputNumber 
                            min={0}
                            label="Kurangi Tabungan(jumlah uang)" 
                            value={kurangiTabungan == 0 ? '' : kurangiTabungan}
                            onChange={(e) => setKurangiTabungan(e.target.value == '' ? 0 : e.target.value)}/>
                        <Card
                            header="Sebelum :"
                            desc1={`Nomer Saham ${parseInt(dataSaham.no_saham ?? '0')} - ${currencyFormat(15000 * (dataSaham.jml_saham ?? 0) * (dataSaham.no_saham ?? 0))}`}
                            desc2={`Tabungan Rp. ${dataSaham.tabungan ?? '0'}`} />
                        <Card
                            header="Diambil / Dikurangi :"
                            desc1={`Nomer Saham ${parseInt(kurangiSaham)} - ${currencyFormat(15000 * (dataSaham.jml_saham ?? 0) * (kurangiSaham))}`}
                            desc2={`Tabungan ${currencyFormat(kurangiTabungan ?? '0')}`} />
                        <Card
                            header="Sesudah :"
                            desc1={`Nomer Saham ${totalNomerSahamKurangi} - ${totalUangSahamKurangi}`}
                            desc2={`Tabungan ${totalTabunganKurangi}`} />
                    </>
                )}
                <div className="mt-15 "></div>
                <SubmitButton disabled={bayarSaham + bayarTabungan + kurangiSaham + kurangiTabungan != 0 && isSubmiting == false ? false : true}>
                    <svg className="inline-block mr-3 icon icon-tabler icons-tabler-outline icon-tabler-plus" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" 
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" 
                        ><path stroke="none" d="M0 0h24v24H0z" 
                        fill="none"/><path d="M12 5l0 14" /><path d="M5 12l14 0" /></svg>
                        SIMPAN TRANSAKSI
                </SubmitButton>
            </form>          
        </>
    );
}

export default TambahTransaksiSaham;